export const CHAIN_SEARCH_TABS = {
    ADD_CHAIN: 'Add Industry',
} as const;

type ChainSearchTabsType = typeof CHAIN_SEARCH_TABS;
export type ChainSearchTabsTypes = ChainSearchTabsType[keyof ChainSearchTabsType];
